export function toSpeakingUrl(input: string) {
  return input
    .toLowerCase()
    .trim()
    .replaceAll('\u200B', '')
    .replaceAll('\u00A0', ' ')
    .replaceAll('&', '-')
    .replaceAll('/', '-')
    .replaceAll(/\r?\n|\r/g, '-')
    .replaceAll("'", '')
    .replaceAll('´', '')
    .replaceAll('`', '')
    .replaceAll('’', '')
    .replaceAll('.', '')
    .replaceAll(',', '')
    .replaceAll('(', '')
    .replaceAll(')', '')
    .replaceAll('[', '')
    .replaceAll(']', '')
    .replaceAll('<', '')
    .replaceAll('>', '')
    .replaceAll('–', '-')
    .replaceAll('—', '-')
    .replaceAll(' - ', '-')
    .replaceAll('- ', '-')
    .replaceAll(' -', '-')
    .replaceAll(' ', '-')
    .replaceAll('--', '-')
    .replaceAll('å', 'a')
    .replaceAll('ä', 'a')
    .replaceAll('ö', 'o')
    .replaceAll('ø', 'o')
    .replaceAll('æ', 'ae')
    .replaceAll('ü', 'u')
    .replaceAll('é', 'e')
    .replaceAll('ó', 'o')
}
